import ContentLoader from 'react-content-loader';

interface IProps {
  hasPreviewImage?: boolean;
  hasOfferTitle?: boolean;
}

export const CMSChoosePaymentPlanSectionLoader = ({ hasPreviewImage, hasOfferTitle }: IProps) => {
  return (
    <>
      {/* preview image loader */}
      {hasPreviewImage && (
        <div className="flex items-center justify-end pb-6 sm:w-1/2">
          <ContentLoader
            backgroundColor="#ffffff"
            uniqueKey="CatchesList-key-3"
            className="aspect-square size-full h-[600px]"
          >
            <rect x="0" y="0" rx="5" ry="5" width="100" height="600" style={{ width: '100%' }} />
          </ContentLoader>
        </div>
      )}
      <div className={`flex w-full flex-col items-center gap-2 sm:w-1/2 sm:max-w-[450px]`}>
        {/* Offer title loader */}
        {hasOfferTitle && (
          <ContentLoader
            backgroundColor="#ffffff"
            uniqueKey="CatchesList-key-1"
            className="size-full h-[28px]"
          >
            <rect
              x="0"
              y="0"
              rx="5"
              ry="5"
              width="100"
              height="40px"
              style={{ width: '100%', height: '40px' }}
            />
          </ContentLoader>
        )}
        {/* Title loader */}
        <ContentLoader
          backgroundColor="#ffffff"
          uniqueKey="CatchesList-key-2"
          className="size-full h-[42px]"
        >
          <rect
            x="0"
            y="0"
            rx="5"
            ry="5"
            width="100"
            height="40px"
            style={{ width: '100%', height: '40px' }}
          />
        </ContentLoader>
        {/* payment plans loader */}
        <ContentLoader
          backgroundColor="#ffffff"
          uniqueKey="CatchesList-key-4"
          className="aspect-square size-full h-[300px]"
        >
          <rect x="0" y="0" rx="5" ry="5" width="100" height="300" style={{ width: '100%' }} />
        </ContentLoader>
      </div>
    </>
  );
};
